import {openPanel} from '../sidePanel-action'

import './slideLeft'

export function slideFromLeft(containerId, data, className=false) {
    return openPanel(containerId, data, 'sidePanel-slideLeft' + (className ? ' ' + className : ''))
}

/**
 * @deprecated
 */
export const sidePanelSlideFromRight = slideFromLeft
